export default {
  'menu.projects': 'Project Management',
  'menu.projects.all': 'All Projects',
  'menu.projects.participated': 'Participated',
  'menu.projects.following': 'Following',
  'menu.projects.tagManagement': 'Tag Management',
  'menu.estimationStandards': 'Estimation Standards Management',
  'menu.devAgents': 'Development Agent Management',
  'menu.projectHome': 'Project Home',
  'menu.projectCharter': 'Project Conventions',
  'menu.projectCharter.projectGoals': 'Goals and Vision',
  'menu.projectCharter.projectPrinciples': 'Principles',
  'menu.projectCharter.projectNotes': 'Notes',
  'menu.productInput': 'Product Input',
  'menu.productInput.inputDashboard': 'Input Board',
  'menu.productInput.issuesIdea': 'Ideas',
  'menu.productInput.issuesRequest': 'Requirement Leads',
  'menu.productInput.referenceProducts': 'Reference Products',
  'menu.productInput.referenceMaterials': 'Reference Links',
  'menu.productInput.userFeedback': 'User Feedback',
  'menu.productInput.easyRecorder': 'Easy Recorder',
  'menu.requirementDefinition': 'Requirement Definition',
  'menu.requirementDefinition.summary': 'Overview Requirements',
  'menu.requirementDefinition.overviewTemplateManagement':
    'Overview Requirement Templates',
  'menu.requirementDefinition.featureList': 'Feature List',
  'menu.requirementDefinition.roleAnalysis': 'Role Analysis',
  'menu.requirementDefinition.conceptAnalysis': 'Concept Analysis',
  'menu.requirementDefinition.systemIntegration': 'System Integration',
  'menu.requirementDefinition.document': 'Requirement Document',
  'menu.deliveryPlanning': 'Delivery Planning',
  'menu.deliveryPlanning.issuesStory': 'Delivery Stories',
  'menu.deliveryPlanning.taskManagement': 'Task Management',
  'menu.deliveryPlanning.estimationStandards': 'Estimation Standards',
  'menu.deliveryPlanning.taskListGeneration': 'Task List Generation',
  'menu.developmentDesign': 'Development Design',
  'menu.developmentDesign.applicationAnalysis': 'Application Analysis',
  'menu.developmentDesign.repositoryManagement': 'Build Application',
  'menu.developmentDesign.modelingAssistant': 'Data Modeling',
  'menu.developmentDesign.aiAssistedDesign': 'Prototype Design',
  'menu.developmentDesign.architecture': 'Architecture Design',
  'menu.developmentDesign.apiManagement': 'API Management',
  'menu.developmentExecution': 'Development Execution',
  'menu.developmentExecution.agentManagement': 'Agent Management',
  'menu.developmentExecution.codeRepository': 'Code Management',
  'menu.developmentExecution.codeMigration': 'Code Migration',
  'menu.testQuality': 'Test Quality',
  'menu.testQuality.testManagement': 'Test Management',
  'menu.testQuality.issuesBug': 'Defects',
  'menu.testQuality.qualityAnalysis': 'Quality Analysis',
  'menu.projectAssets': 'Project Assets',
  'menu.projectAssets.assetLibrary': 'Asset Library',
  'menu.projectAssets.daily-report-management': 'Daily Reports',
  'menu.projectAssets.quote-management': 'Quotes',
  'menu.projectAssets.auditLog': 'Audit Log',
  'menu.productionDashboard': 'Production Dashboard',
  'menu.projectDashboard': 'Production Dashboard',
  'menu.projectDashboard.dashboard': 'Dashboard',
  'menu.dailyManagement': 'Daily Management',
  'menu.dailyManagement.taskManagement': 'Task Management',
  'menu.dailyManagement.communicationRecords': 'Communication Records',
  'menu.dailyManagement.issueTracker': 'Issue Tracker',
  'menu.dailyManagement.issueTracker.bug': 'Bug',
  'menu.dailyManagement.issueTracker.userFeedback': 'User Feedback',
  'menu.dailyManagement.issueTracker.risk': 'Risk',
  'menu.dailyManagement.issueTracker.problem': 'Problem',
  'menu.dailyManagement.issueTracker.changeRequest': 'Change Request',
  'menu.dailyManagement.issueTracker.pendingConfirmation':
    'Pending Confirmation',
  'menu.dailyManagement.dailyReportManagement': 'Daily Report Management',
  'menu.requirementAnalysis': 'Requirement Analysis',
  'menu.requirementAnalysis.requirementPool': 'Requirement Pool',
  'menu.requirementAnalysis.structuredAnalysis': 'Structured Analysis',
  'menu.requirementAnalysis.highLevelRequirements': 'High-Level Requirements',
  'menu.requirementAnalysis.featureList': 'Feature List',
  'menu.requirementAnalysis.prd': 'Product Requirement Document',
  'menu.prototypeDesign': 'Prototype Design',
  'menu.prototypeDesign.brandDesign': 'Brand Design',
  'menu.prototypeDesign.uiGuidelines': 'UI Guidelines',
  'menu.prototypeDesign.informationArchitecture': 'Information Architecture',
  'menu.prototypeDesign.menuPlanning': 'Menu Planning',
  'menu.prototypeDesign.pageDesign': 'Page Design',
  'menu.prototypeDesign.interactionFlow': 'Interaction Flow',
  'menu.prototypeDesign.aiAssistedDesign': 'AI Page Design',
  'menu.prototypeDesign.prototypePreview': 'Prototype Preview',
  'menu.architectureDesign': 'Architecture Design',
  'menu.architectureDesign.architectureOverview': 'Architecture Overview',
  'menu.architectureDesign.applicationArchitecture': 'Application Architecture',
  'menu.architectureDesign.technicalStandards': 'Technical Standards',
  'menu.architectureDesign.dataModeling': 'Data Modeling',
  'menu.architectureDesign.apiDesign': 'API Design',
  'menu.architectureDesign.permissionModel': 'Permission Model',
  'menu.architectureDesign.integrationDesign': 'Integration Design',
  'menu.architectureDesign.adr': 'Architecture Decision Records',
  'menu.developmentExecution.applicationManagement': 'Application Management',
  'menu.developmentExecution.developmentTasks': 'Development Tasks',
  'menu.developmentExecution.codeManagement': 'Code Management',
  'menu.developmentExecution.codeActivity': 'Code Activity',
  'menu.developmentExecution.buildRecords': 'Build Records',
  'menu.agentsManagement': 'Agents Management',
  'menu.agentsManagement.agentWorkspace': 'Agent Workspace',
  'menu.agentsManagement.projectAgents': 'Project Agents',
  'menu.testingQuality': 'Testing & Quality',
  'menu.testingQuality.testingOverview': 'Testing Overview',
  'menu.testingQuality.testPlan': 'Test Plan',
  'menu.testingQuality.testCases': 'Test Cases',
  'menu.testingQuality.testExecution': 'Test Execution',
  'menu.testingQuality.qualityAnalysis': 'Quality Analysis',
  'menu.testingQuality.acceptanceManagement': 'Acceptance Management',
  'menu.deploymentOperations': 'Deployment & Operations',
  'menu.deploymentOperations.console': 'Deployment Console',
  'menu.deploymentOperations.pipelines': 'Pipeline History',
  'menu.deploymentOperations.runtime': 'Runtime Monitor',
  'menu.deploymentOperations.coralApplicationPublication':
    'Application listing',
  'menu.releaseDelivery': 'Release & Delivery',
  'menu.releaseDelivery.versionManagement': 'Version Management',
  'menu.releaseDelivery.releasePlan': 'Release Plan',
  'menu.releaseDelivery.releaseRecords': 'Release Records',
  'menu.releaseDelivery.deliverablesManagement': 'Deliverables Management',
  'menu.releaseDelivery.coralApplicationPublication': 'Application listing',
  'menu.researchReferences': 'Research & References',
  'menu.researchReferences.referenceMaterials': 'Reference Materials',
  'menu.researchReferences.competitorManagement': 'Competitor Management',
  'menu.researchReferences.competitorAnalysis': 'Competitor Analysis',
  'menu.researchReferences.competitorAnalysisReport':
    'Competitor Analysis Report',
  'menu.buildingAssets': 'Building Assets',
  'menu.buildingAssets.imageAssets': 'Image Assets',
  'menu.buildingAssets.iconAssets': 'Icon Assets',
  'menu.projectAssets.projectDocuments': 'Project Documents',
  'menu.projectAssets.deliverables': 'Deliverables',
  'menu.businessManagement': 'Business Management',
  'menu.businessManagement.quotationManagement': 'Quotation Management',
  'menu.businessManagement.contractInformation': 'Contract Information',
  'menu.businessManagement.paymentPlan': 'Payment Plan',
  'menu.businessManagement.changeQuotation': 'Change Quotation',
  'menu.projectSettings.memberManagement': 'Member Management',
  'menu.projectSettings.projectDetail': 'Project Details',
  'menu.projectSettings.auditLogs': 'Audit Logs',
  'menu.projectSettings.projectAnnouncements': 'Project Announcements',
  'menu.projectGoals': 'Project Conventions',
  'menu.projectCollection': 'Project Summary',
  'menu.projectCollection.projectHome': 'Project Home',
  'menu.projectCollection.projectGoals': 'Project Conventions',
  'menu.applicationManagement': 'Application Management',
  'menu.applicationManagement.repositoryManagement': 'Build Application',
  'menu.applicationManagement.applicationAnalysis': 'Application Analysis',
  'menu.application': 'Application Management',
  'menu.communication': 'Communication Records',
  'menu.requirements': 'Requirement Analysis',
  'menu.requirements.summary': 'Requirement Summary',
  'menu.requirements.overviewTemplateManagement':
    'Overview Template Management',
  'menu.requirements.featureList': 'Feature List',
  'menu.requirements.document': 'Requirement Document',
  'menu.requirements.roleAnalysis': 'Role Analysis',
  'menu.requirements.conceptAnalysis': 'Concept Analysis',
  'menu.requirements.conceptAnalysis.management': 'Concept Management',
  'menu.requirements.conceptAnalysis.group': 'Concept Grouping',
  'menu.requirements.conceptAnalysis.relation': 'Concept Relations',
  'menu.conceptAnalysis': 'Concept Analysis',
  'menu.conceptAnalysis.management': 'Concept Management',
  'menu.conceptAnalysis.group': 'Concept Grouping',
  'menu.conceptAnalysis.relation': 'Concept Relations',
  'menu.requirements.applicationAnalysis': 'Application Analysis',
  'menu.requirements.projectGoals': 'Project Conventions',
  'menu.dataModeling': 'Data Modeling',
  'menu.dataModeling.modelingAssistant': 'Modeling Assistant',
  'menu.dataModeling.entityManagement': 'Entity Management',
  'menu.dataModeling.ruleManagement': 'Rule Management',
  'menu.dataModeling.dataSourceManagement': 'Data Source Management',
  'menu.requirements.systemIntegration': 'System Integration',
  'menu.prototype': 'Prototype Design',
  'menu.prototype.aiAssistedDesign': 'AI Page Design',
  'menu.prototype.statisticalAnalysisPageDesign':
    'Statistical Analysis Page Design',
  'menu.prototype.bigScreenPageDesign': 'Big Screen Page Design',
  'menu.prototype.designManagement': 'Page Management',
  'menu.prototype.themeDesign': 'Theme Design',
  'menu.architecture': 'Architecture Design',
  'menu.architecture.overview': 'Architecture Overview',
  'menu.architecture.detail': 'Architecture Detail',
  'menu.agentManagement': 'Agent Management',
  'menu.developmentManagement': 'Development Management',
  'menu.developmentManagement.agentManagement': 'Agent Management',
  // 'menu.developmentManagement.devAgentV1Planning': 'Dev Agent V1 Task Planning',
  // 'menu.developmentManagement.devAgentV1': 'Dev Agent V1 Run Board',
  // 'menu.developmentManagement.projectBlueprint': 'Project Blueprint',
  'menu.architecture.codeManagement': 'Code Management',
  'menu.architecture.apiManagement': 'API Management',
  'menu.codeManagement': 'Code Management',
  'menu.codeManagement.codeRepository': 'Code Repository',
  'menu.codeManagement.codeMigration': 'Code Migration',
  'menu.codeManagement.dependencyAnalysis': 'Dependency Analysis',
  'menu.apiManagement': 'API Management',
  'menu.apiManagement.apiList': 'API List',
  'menu.apiManagement.apiQuickDebug': 'API Quick Debug',
  'menu.testManagement': 'Test Management',
  'menu.testManagement.dashboard': 'Dashboard',
  'menu.testManagement.bug': 'BUG',
  'menu.testManagement.case': 'Test Case',
  'menu.testManagement.suite': 'Test Suite',
  'menu.testManagement.order': 'Test Order',
  'menu.testManagement.report': 'Test Report',
  'menu.testManagement.caseLibrary': 'Case Library',
  'menu.qualityManagement': 'Quality Management',
  'menu.qualityManagement.qualityAnalysis': 'Quality Analysis',
  'menu.knowledgeBase': 'Reference Links',
  'menu.knowledgeBase.referenceProducts': 'Reference Products',
  'menu.knowledgeBase.referenceMaterials': 'Reference Links',
  'menu.assetLibrary': 'Asset Library',
  'menu.projectSettings': 'Project Settings',
  'menu.projectSettings.projectMember': 'Project and Members',
  'menu.projectSettings.projectCollaboration': 'Project Collaboration',
  'menu.projectSettings.projectAnnouncement': 'Project Announcement',
  'menu.projectSettings.projectTags': 'Project Tags',
  'menu.projectSettings.developerOptions': 'Developer Options',
  // ── New Navigation Domains ────────────────────────────────
  'menu.workbench': 'Workbench',
  'menu.workbenchTodo': 'My Tasks',
  'menu.workbenchRisk': 'Risk Alerts',
  'menu.workbenchActivity': 'Recent Activity',
  'menu.workbenchDashboard': 'Business Dashboard',
  'menu.workbench.workbenchTodo': 'My Tasks',
  'menu.workbench.workbenchRisk': 'Risk Alerts',
  'menu.workbench.workbenchActivity': 'Recent Activity',
  'menu.workbench.workbenchDashboard': 'Business Dashboard',
  'menu.customer': 'Customer',
  'menu.customerList': 'Customer Library',
  'menu.customerKanban': 'Customer Kanban',
  'menu.customerKeyPerson': 'Key Persons',
  'menu.customerExistingSystem': 'Existing Systems',
  'menu.customerTag': 'Customer Tags',
  'menu.customerMaterial': 'Materials & Summaries',
  'menu.customer.customerList': 'Customer Library',
  'menu.customer.customerKanban': 'Customer Kanban',
  'menu.customer.customerKeyPerson': 'Key Persons',
  'menu.customer.customerExistingSystem': 'Existing Systems',
  'menu.customer.customerTag': 'Customer Tags',
  'menu.customer.customerMaterial': 'Materials & Summaries',
  'menu.solution': 'Solution',
  'menu.solutionList': 'Solution Library',
  'menu.solutionTemplate': 'Solution Templates',
  'menu.solutionQuestion': 'Survey Question Bank',
  'menu.solutionCaseLibrary': 'Case Library',
  'menu.solutionPainPoint': 'Pain Points',
  'menu.solutionPlaybook': 'Playbooks',
  'menu.solutionTalkTrack': 'Talk Tracks',
  'menu.solution.solutionList': 'Solution Library',
  'menu.solution.solutionKanban': 'Solution Kanban',
  'menu.solution.solutionQuote': 'Quotations',
  'menu.solution.solutionReview': 'Solution Review',
  'menu.solution.solutionQuestion': 'Survey Question Bank',
  'menu.solution.solutionQuestionPack': 'Question Packs',
  'menu.solution.solutionTemplate': 'Solution Templates',
  'menu.delivery': 'Delivery',
  'menu.deliveryProjectList': 'Project List',
  'menu.deliveryKanban': 'Project Kanban',
  'menu.deliveryEstimationStandard': 'Estimation Standards',
  'menu.deliveryOverview': 'Delivery Overview',
  'menu.delivery.deliveryProject': 'Project List',
  'menu.delivery.deliveryKanban': 'Project Kanban',
  'menu.delivery.deliveryMyTask': 'My Tasks',
  'menu.delivery.deliveryStageGate': 'Milestones',
  'menu.delivery.deliveryRisk': 'Risk Management',
  'menu.delivery.deliveryResource': 'Resources',
  'menu.delivery.deliveryTemplate': 'Delivery Templates',
  'menu.delivery.deliveryModelSettings': 'Model Settings',
  'menu.service': 'Service',
  'menu.serviceRecord': 'Service Records',
  'menu.serviceSatisfaction': 'Satisfaction',
  'menu.serviceIssueTracker': 'Issue Tracker',
  'menu.serviceHealthDashboard': 'Health Dashboard',
  'menu.service.serviceOverview': 'Service Overview',
  'menu.service.serviceTicket': 'Tickets',
  'menu.service.serviceFeedback': 'Customer Feedback',
  'menu.service.serviceHealth': 'Health Score',
  'menu.service.serviceUsage': 'Usage Analytics',
  'menu.service.serviceDemand': 'Phase 2 Demand',
  'menu.service.serviceRenewal': 'Renewal & Upsell',
  'menu.service.serviceReport': 'Service Reports',
  'menu.asset': 'Assets',
  'menu.assetMethod': 'Methodology Library',
  'menu.assetTemplate': 'Template Library',
  'menu.assetMaterial': 'Material Library',
  'menu.assetKnowledgeBase': 'Knowledge Base',
  'menu.asset.assetOverview': 'Asset Overview',
  'menu.asset.assetMethod': 'Methodology Library',
  'menu.asset.assetSolution': 'Solution Assets',
  'menu.asset.assetDesign': 'Design Assets',
  'menu.asset.assetDevelopment': 'Dev Assets',
  'menu.asset.assetTesting': 'Testing Assets',
  'menu.asset.assetDelivery': 'Delivery Assets',
  'menu.asset.assetIntelligence': 'AI & Agents',
  'menu.asset.assetOperation': 'Operation Assets',
  'menu.admin': 'Admin',
  'menu.adminMember': 'Members',
  'menu.adminRole': 'Roles & Permissions',
  'menu.adminTenant': 'Company Settings',
  'menu.adminAgent': 'Agent Management',
  'menu.adminEventEngine': 'Event Engine',
  'menu.adminSecurity': 'Security Audit',
  'menu.admin.adminOrganization': 'Organization',
  'menu.admin.adminCustomerProjectConfig': 'Project Config',
  'menu.admin.adminDictionary': 'Dictionaries',
  'menu.admin.adminWorkflow': 'Workflows',
  'menu.admin.adminPricing': 'Pricing',
  'menu.admin.adminAi': 'AI Config',
  'menu.admin.adminAgent': 'Agent Management',
  'menu.admin.adminIntegration': 'Integrations',
  'menu.admin.adminEventEngine': 'Event Engine',
  'menu.admin.adminSecurity': 'Security Audit',
  // ── Customer Workspace ────────────────────────────────────
  'menu.customerWorkspaceProfile': 'Profile',
  'menu.customerWorkspaceOrganization': 'Org Chart',
  'menu.customerWorkspaceSystem': 'Existing Systems',
  'menu.customerWorkspaceMaterial': 'Research Materials',
  'menu.customerWorkspaceSolution': 'Solutions',
  'menu.customerWorkspaceProject': 'Projects',
  'menu.customerWorkspaceServiceRecord': 'Service Records',
  'menu.customerWorkspaceRetrospective': 'Retrospective',
  // ── Solution Workspace ────────────────────────────────────
  'menu.solutionWorkspaceOverview': 'Overview',
  'menu.solutionWorkspaceDiagnosis': 'Diagnosis',
  'menu.solutionWorkspacePainPoint': 'Pain Points',
  'menu.solutionWorkspaceProposal': 'Proposal Doc',
  'menu.solutionWorkspaceDemo': 'Demo Materials',
  'menu.solutionWorkspaceTimeline': 'Timeline',
  'menu.solutionWorkspaceKeyPerson': 'Key Persons',
  'menu.solutionWorkspaceCompetitor': 'Competitor Analysis',
  'menu.solutionWorkspaceFeedback': 'Customer Feedback',
  'menu.solutionWorkspaceDecision': 'Decision Log',
  // ── Project Workspace ─────────────────────────────────────
  'menu.projectWorkspaceOverview': 'Overview',
  'menu.projectWorkspaceRequirement': 'Requirements',
  'menu.projectWorkspaceDelivery': 'Delivery',
  'menu.projectWorkspaceDesign': 'Design',
  'menu.projectWorkspaceDev': 'Development',
  'menu.projectWorkspaceTest': 'Testing',
  'menu.projectWorkspaceAsset': 'Assets',
  // ── Solution Sub-menus ────────────────────────────────────
  'menu.solutionKanban': 'Solution Kanban',
  'menu.solutionQuote': 'Quotations',
  'menu.solutionReview': 'Solution Review',
  'menu.solutionQuestionPack': 'Question Packs',
  // ── Delivery Sub-menus ────────────────────────────────────
  'menu.deliveryProject': 'Project List',
  'menu.deliveryMyTask': 'My Tasks',
  'menu.deliveryStageGate': 'Milestones',
  'menu.deliveryRisk': 'Risk Management',
  'menu.deliveryResource': 'Resources',
  'menu.deliveryTemplate': 'Delivery Templates',
  'menu.deliveryModelSettings': 'Model Settings',
  // ── Service Sub-menus ─────────────────────────────────────
  'menu.serviceOverview': 'Service Overview',
  'menu.serviceTicket': 'Tickets',
  'menu.serviceFeedback': 'Customer Feedback',
  'menu.serviceHealth': 'Health Score',
  'menu.serviceUsage': 'Usage Analytics',
  'menu.serviceDemand': 'Phase 2 Demand',
  'menu.serviceRenewal': 'Renewal & Upsell',
  'menu.serviceReport': 'Service Reports',
  // ── Asset Sub-menus ───────────────────────────────────────
  'menu.assetOverview': 'Asset Overview',
  'menu.assetSolution': 'Solution Assets',
  'menu.assetDesign': 'Design Assets',
  'menu.assetDevelopment': 'Dev Assets',
  'menu.assetTesting': 'Testing Assets',
  'menu.assetDelivery': 'Delivery Assets',
  'menu.assetIntelligence': 'AI & Agents',
  'menu.assetOperation': 'Operation Assets',
  // ── Admin Sub-menus ───────────────────────────────────────
  'menu.adminOrganization': 'Organization',
  'menu.adminCustomerProjectConfig': 'Project Config',
  'menu.adminDictionary': 'Dictionaries',
  'menu.adminWorkflow': 'Workflows',
  'menu.adminPricing': 'Pricing',
  'menu.adminAi': 'AI Config',
  'menu.adminIntegration': 'Integrations',
  // ─────────────────────────────────────────────────────────
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.system': 'System',
  'menu.system.menu': 'Menu',
  'menu.system.user': 'User',
  'menu.system.role': 'Role',
  'menu.template': 'Template',
  'menu.login': 'Login',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.workbench': 'Back to Workbench',
  'menu.account.tenantManagement': 'Tenant Management',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.auditLog': 'Audit Log',
  'menu.tabs.refresh': 'Refresh Tab',
  'menu.tabs.closeCurrent': 'Close Tab',
  'menu.tabs.closeOthers': 'Close Others',
  'menu.tabs.closeRight': 'Close Right',
  'menu.tabs.closeAll': 'Close All',
  'menu.tabs.scrollLeft': 'Scroll Left',
  'menu.tabs.scrollRight': 'Scroll Right',
  'menu.tabs.manage': 'Manage Tabs',
  'menu.tabs.unnamed': 'Unnamed Page',
  'menu.项目管理': 'Project Management',
  'menu.工时评估标准管理': 'Estimation Standards Management',
  'menu.开发Agent管理': 'Development Agent Management',
  'menu.项目列表': 'Projects',
  'menu.项目主页': 'Project Home',
  'menu.应用管理': 'Application Management',
  'menu.应用管理.搭建应用': 'Repository Management',
  'menu.沟通记录': 'Communication Records',
  'menu.需求分析': 'Requirement Analysis',
  'menu.需求分析.需求概要': 'Requirement Summary',
  'menu.需求分析.功能清单': 'Feature List',
  'menu.需求分析.需求文档': 'Requirement Document',
  'menu.页面设计': 'Prototype Design',
  'menu.架构设计': 'Architecture Design',
  'menu.架构设计.概要设计': 'Architecture Overview',
  'menu.架构设计.详细设计': 'Architecture Detail',
  'menu.任务管理': 'Task Management',
  'menu.缺陷管理': 'Defect Management',
  'menu.测试管理': 'Test Management',
  'menu.质量管理': 'Quality Management',
  'menu.日报管理': 'Daily Report Management',
  'menu.报价管理': 'Quotation Management',
  'menu.知识库': 'Reference Materials',
  'menu.素材库': 'Asset Library',
  'menu.审计日志': 'Audit Log',
  'menu.需求分析.角色分析': 'Role Analysis',
  'menu.需求分析.概念分析': 'Concept Analysis',
  'menu.需求分析.应用分析': 'Application Analysis',
  'menu.需求分析.项目目标': 'Project Conventions',
  'menu.需求分析.数据建模': 'Data Modeling',
  'menu.数据建模.AI辅助建模': 'Modeling Assistant',
  'menu.数据建模.实体管理': 'Entity Management',
  'menu.需求分析.系统对接': 'System Integration',
  'menu.taskManagement': 'Task Management',
  'menu.issues': 'Issues',
  'menu.issues.issuesAll': 'All',
  'menu.issues.issuesBug': 'Defect',
  'menu.issues.issuesStory': 'Delivery Story',
  'menu.issues.issuesFeature': 'New Feature',
  'menu.issues.issuesImprovement': 'Improvement',
  'menu.issues.issuesIdea': 'Ideas',
  'menu.issues.issuesRequest': 'Requirement Leads',
  'menu.issues.issuesConfirmation': 'Items Pending Confirmation',
  'menu.issues.issuesNote': 'Note',
  'menu.daily-report-management': 'Daily Report Management',
  'menu.quote-management': 'Quotation Management',
  'menu.customerIntelligence': 'Customer Intelligence',
  'menu.customerIntelligence.customerList': 'Customer List',
  'menu.solutionAdvancement': 'Solution Advancement',
  'menu.fieldResearch': 'Field Research',
  'menu.fieldResearch.fieldResearchRecords': 'Research Records',
  'menu.fieldResearch.fieldResearchPanel': 'Research Panel',
  'menu.methodologyCenter': 'Methodology Center',
  'menu.methodologyCenter.industryCases': 'Industry Cases',
  'menu.methodologyCenter.problemPainPoints': 'Issues & Pain Points',
  'menu.methodologyCenter.commonPainPoints': 'Issues & Pain Points',
  'menu.methodologyCenter.solutionPlaybooks': 'Solution Playbooks',
  'menu.methodologyCenter.pilotScenes': 'Pilot Scenes',
  'menu.methodologyCenter.talkTracks': 'Talk Tracks',
  'menu.methodologyCenter.failureReasons': 'Failure Reasons',
  'menu.methodologyCenter.successPlaybooks': 'Success Playbooks',
  'menu.methodologyCenter.industryTemplates': 'Industry Templates',
  'menu.methodologyCenter.analysisLogics': 'Analysis Logics',
  'menu.zyConsultantOperations': 'Consultant Operations',
  'menu.zyConsultantOperations.diagnosisSessions': 'Diagnosis Sessions',
  'menu.zyConsultantOperations.questionBank': 'Question Bank',
  'menu.zyConsultantOperations.questionPacks': 'Question Packs',
  'menu.zyConsultantOperations.zySettings': 'Settings',

  // ── Old /projects children (parent has no name → flat keys) ──
  'menu.all': 'All Projects',
  'menu.participated': 'Participated',
  'menu.following': 'Following',
  'menu.tagManagement': 'Tag Management',

  // ── Hidden route breadcrumb (parent.child format) ─────────────
  'menu.delivery.deliveryOverview': 'Delivery Overview',

  // ── Old /project sub-route flat keys ─────────────────────────
  'menu.inputDashboard': 'Input Board',
  'menu.userFeedback': 'User Feedback',
  'menu.issuesAll': 'All',
  'menu.issuesBug': 'Defect',
  'menu.issuesStory': 'Delivery Story',
  'menu.issuesFeature': 'New Feature',
  'menu.issuesImprovement': 'Improvement',
  'menu.issuesIdea': 'Ideas',
  'menu.issuesRequest': 'Requirement Leads',
  'menu.issuesConfirmation': 'Items Pending Confirmation',
  'menu.issuesNote': 'Note',
  'menu.taskListGeneration': 'Task List Generation',
  'menu.summary': 'Overview Requirements',
  'menu.overviewTemplateManagement': 'Overview Templates',
  'menu.featureList': 'Feature List',
  'menu.roleAnalysis': 'Role Analysis',
  'menu.systemIntegration': 'System Integration',
  'menu.document': 'Requirement Document',
  'menu.management': 'Concept Management',
  'menu.group': 'Concept Grouping',
  'menu.relation': 'Concept Relations',
  'menu.applicationAnalysis': 'Application Analysis',
  'menu.repositoryManagement': 'Build Application',
  'menu.modelingAssistant': 'Modeling Assistant',
  'menu.ruleManagement': 'Rule Management',
  'menu.dataSourceManagement': 'Data Source Management',
  'menu.aiAssistedDesign': 'AI Page Design',
  'menu.themeDesign': 'Theme Design',
  'menu.statisticalAnalysisPageDesign': 'Statistical Analysis Page Design',
  'menu.bigScreenPageDesign': 'Big Screen Page Design',
  'menu.designManagement': 'Page Management',
  'menu.overview': 'Architecture Overview',
  'menu.detail': 'Architecture Detail',
  'menu.codeRepository': 'Code Repository',
  'menu.codeMigration': 'Code Migration',
  'menu.dependencyAnalysis': 'Dependency Analysis',
  'menu.apiList': 'API List',
  'menu.apiQuickDebug': 'API Quick Debug',
  'menu.bug': 'BUG',
  'menu.case': 'Test Case',
  'menu.suite': 'Test Suite',
  'menu.order': 'Test Order',
  'menu.report': 'Test Report',
  'menu.caseLibrary': 'Case Library',
  'menu.qualityAnalysis': 'Quality Analysis',
  'menu.referenceProducts': 'Reference Products',
  'menu.referenceMaterials': 'Reference Links',
  'menu.projectMember': 'Project and Members',
  'menu.projectCollaboration': 'Project Collaboration',
  'menu.projectAnnouncement': 'Project Announcement',
  'menu.projectTags': 'Project Tags',
  'menu.developerOptions': 'Developer Options',
};
